import { IS_LOADING, PLAYER_ACC_LIST_SUCCESS, PLAYER_ACC_LIST_ERROR, SERIES_DROP_LIST_SUCCESS, SERIES_DROP_LIST_ERROR, MATCH_DROP_LIST_SUCCESS, MATCH_DROP_LIST_ERROR, PLAYER_ACC_UPDATE_SUCCESS, PLAYER_ACC_UPDATE_ERROR } from "../actions/Type";

const initialState = {
    player_acc_list: {},
    loading: false,
    series_list: {},
    match_list: {},
    player_acc_update: {}
};

export const AccumulatorReducers = (
    state = initialState,
    { type, payload } = {},
) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case PLAYER_ACC_UPDATE_SUCCESS:
            return {
                ...state,
                player_acc_update: payload,
                loading: false,
            };
        case PLAYER_ACC_UPDATE_ERROR:
            return {
                ...state,
                player_acc_update: payload,
                loading: false,
            };
        case SERIES_DROP_LIST_SUCCESS:
            return {
                ...state,
                series_list: payload,
                loading: false,
            };
        case SERIES_DROP_LIST_ERROR:
            return {
                ...state,
                series_list: payload,
                loading: false,
            };
        case MATCH_DROP_LIST_SUCCESS:
            return {
                ...state,
                match_list: payload,
                loading: false,
            };
        case MATCH_DROP_LIST_ERROR:
            return {
                ...state,
                match_list: payload,
                loading: false,
            };
        case PLAYER_ACC_LIST_SUCCESS:
            return {
                ...state,
                player_acc_list: payload,
                loading: false,
            };
        case PLAYER_ACC_LIST_ERROR:
            return {
                ...state,
                player_acc_list: payload,
                loading: false,
            };
        default:
            return state;
    }
};
